import React from 'react';
import Navigation from 'Components/Navigation';
import LoadingPageContent from 'Components/LoadingPageContent';
import ChangePasswordForm from 'Components/ChangePasswordForm';
import { userService } from 'Services';
import { withRouter } from 'Components/withRouter';
import styles from './ChangePasswordPage.module.css';

class ChangePasswordPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

        this.onFormSubmit = this.onFormSubmit.bind(this);
    }

    onFormSubmit(formData) {
        userService.changePassword(
            formData.get("existingPassword"),
            formData.get("newPassword")
            )
            .then(response => {
                if (response.status === 200) {
                    this.props.router.navigate('/password_changed');
                }

            })
            .catch(error => console.log(error));
    }

    render() {
        
        return (
            <div>
                <Navigation authenticatedUser={this.props.authenticatedUser} />
                <div className="container-fluid padding-lr55 bg-form">
                    <div className="row h3">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" styleName="styles.pageTitle">Change Password</div>
                    </div>
                </div>
                <div className="container-fluid padding-lr55" styleName="styles.form">
                    <ChangePasswordForm
                        onFormSubmit={this.onFormSubmit}
                        />
                </div>
            </div>
            );
    }
}

const ChangePasswordPageWithRouter = withRouter(ChangePasswordPage);

export { ChangePasswordPageWithRouter as ChangePasswordPage };